import { ChangeDetectionStrategy, Component, forwardRef, inject, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgClass } from '@angular/common';

import { InputTransformFn, NgxMaskDirective } from 'ngx-mask';
import { isNil } from 'lodash';

import { IInputMaskConfig } from '@pages/office/models/input-mask-config.model';

//NOTE: We don't use a mask for the value formatting from API to format values ​​with two digits ​​after the decimal point, as it does in Vista.
@Component({
  selector: 'app-input-percent',
  templateUrl: 'input-percent.component.html',
  styles: `
    :host {
      width: 100%;
    }
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgxMaskDirective, NgClass, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputPercentComponent),
      multi: true,
    },
  ],
})
export class InputPercentComponent implements OnInit, ControlValueAccessor {
  @Input() class: string;
  @Input() placeholder: string;
  @Input() name: string;
  @Input() controlName: string;
  @Input() inputMaskConfig: IInputMaskConfig;
  @Input() inputTransformFn: InputTransformFn;

  public value: string;
  public control: AbstractControl | null = null;
  public innerControl = new FormControl<string>(null);

  private controlContainer = inject(ControlContainer);

  ngOnInit(): void {
    if (this.controlContainer && this.controlContainer.control) {
      this.control = this.controlContainer.control.get([this.controlName]);
    }
  }

  public onBlur(): void {
    this.onChange(this.innerControl.value);
    this.onTouched();
  }

  writeValue(value: number): void {
    this.innerControl.setValue(!isNil(value) ? (Math.round(value * 10000) / 100).toFixed(2) : null);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = (value: string): void => {
      fn(!isNil(value) && value.length !== 0 ? (Math.round(parseFloat(value) * 100) / 10000).toString() : null);
      this.innerControl.setValue(
        !isNil(value) && value.length !== 0 ? (Math.round((parseFloat(value) + Number.EPSILON) * 100) / 100).toFixed(2) : null
      );
    };
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.innerControl.disable();
    } else {
      this.innerControl.enable();
    }
  }

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};
}
